module.exports = __webpack_public_path__ + "img/home-53-hero_16x9_en_poster.287d411.jpg";